import Mousetrap from 'mousetrap';

export function bindKeyboardShortcuts(canAccessSetup: boolean) {
    Mousetrap.bind('c c', () => {
        const event = new CustomEvent('client-navigate', {
            detail: {
                type: 'replace',
                to: {
                    hash: '/create/accounts',
                    search: location.search,
                    state: {
                        modal: true,
                    },
                },
            },
        });
        document.dispatchEvent(event);

        return false;
    });

    Mousetrap.bind('c p', () => {
        const event = new CustomEvent('client-navigate', {
            detail: {
                type: 'replace',
                to: {
                    hash: '/create/contacts',
                    search: location.search,
                    state: {
                        modal: true,
                    },
                },
            },
        });
        document.dispatchEvent(event);

        return false;
    });

    Mousetrap.bind('c l', () => {
        const event = new CustomEvent('client-navigate', {
            detail: {
                type: 'replace',
                to: {
                    hash: '/create/leads',
                    search: location.search,
                    state: {
                        modal: true,
                    },
                },
            },
        });
        document.dispatchEvent(event);

        return false;
    });

    Mousetrap.bind('c t', () => {
        const event = new CustomEvent('client-navigate', {
            detail: {
                type: 'replace',
                to: {
                    hash: '/create/tasks',
                    search: location.search,
                    state: {
                        modal: true,
                    },
                },
            },
        });
        document.dispatchEvent(event);

        return false;
    });

    Mousetrap.bind('c a', () => {
        const event = new CustomEvent('client-navigate', {
            detail: {
                type: 'replace',
                to: {
                    hash: '/create/activities',
                    search: location.search,
                    state: {
                        modal: true,
                    },
                },
            },
        });
        document.dispatchEvent(event);

        return false;
    });

    Mousetrap.bind('g 1', () => {
        const event = new CustomEvent('client-navigate', {
            detail: {
                type: 'replace',
                to: {
                    pathname: '/sales/dashboard',
                },
            },
        });
        document.dispatchEvent(event);

        return false;
    });

    Mousetrap.bind('g 2', () => {
        const event = new CustomEvent('client-navigate', {
            detail: {
                type: 'replace',
                to: {
                    pathname: '/marketing/dashboard',
                },
            },
        });
        document.dispatchEvent(event);

        return false;
    });

    Mousetrap.bind('g 3', () => {
        const event = new CustomEvent('client-navigate', {
            detail: {
                type: 'replace',
                to: {
                    pathname: '/inbox/dashboard',
                },
            },
        });
        document.dispatchEvent(event);

        return false;
    });

    Mousetrap.bind('g c', () => {
        const event = new CustomEvent('client-navigate', {
            detail: {
                type: 'replace',
                to: {
                    pathname: '/companies',
                },
            },
        });
        document.dispatchEvent(event);

        return false;
    });

    Mousetrap.bind('g p', () => {
        const event = new CustomEvent('client-navigate', {
            detail: {
                type: 'replace',
                to: {
                    pathname: '/people',
                },
            },
        });
        document.dispatchEvent(event);

        return false;
    });

    Mousetrap.bind('g l', () => {
        const event = new CustomEvent('client-navigate', {
            detail: {
                type: 'replace',
                to: {
                    pathname: '/leads',
                },
            },
        });
        document.dispatchEvent(event);

        return false;
    });

    Mousetrap.bind('g r', () => {
        const event = new CustomEvent('client-navigate', {
            detail: {
                type: 'replace',
                to: {
                    pathname: '/reports/sales/details',
                },
            },
        });
        document.dispatchEvent(event);

        return false;
    });

    Mousetrap.bind('g s', () => {
        const event = new CustomEvent('client-navigate', {
            detail: {
                type: 'replace',
                to: {
                    pathname: canAccessSetup ? '/setup/index' : '/my-account/settings',
                },
            },
        });
        document.dispatchEvent(event);

        return false;
    });
}

export function unbindKeyboardShortcuts() {
    // Unbind all the shortcuts we previously bound
    Mousetrap.unbind([
        'c c',
        'c p',
        'c l',
        'c t',
        'c a',
        'g 1',
        'g 2',
        'g 3',
        'g c',
        'g p',
        'g l',
        'g r',
        'g s',
    ]);
}
